import { useLocale } from '../i18n/LocaleContext';
import { SectionTitle } from './ui';

const AboutApp = ({ data }) => {
  const { t } = useLocale();

  return (
    <>
      <SectionTitle>{t.aboutApp.title}</SectionTitle>
      <p>{data.aboutApp}</p>
    </>
  );
};

export default AboutApp;
